import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/hero/space-triangle.webp'
import _imports_1 from '../assets/hero/triangle-right.webp'
import _imports_2 from '../assets/hero/logo.webp'
import _imports_3 from '../assets/hero/triangle-left.webp'


const _hoisted_1 = { class: "landing-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = {
  style: {"position":"relative"},
  class: "container"
}
const _hoisted_4 = { class: "hero__wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "hero__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "hero__triangles hero__triangle_left",
    src: _imports_0,
    alt: "traingle left"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "hero__triangles hero__triangle_right",
    src: _imports_1,
    alt: "traingle right"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "hero__logo_image-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "hero__logo_image",
      src: _imports_2,
      alt: "logo"
    })
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    class: "hero__triangles hero__triangle_bottom",
    src: _imports_3,
    alt: "traingle right"
  })
], -1)
const _hoisted_6 = { class: "hero__content" }
const _hoisted_7 = { class: "hero__title" }
const _hoisted_8 = { class: "hero__sub-title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "18",
    cy: "18.5",
    r: "10",
    fill: "#EDB94A"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "18",
    cy: "18.5",
    r: "14",
    stroke: "#EDB94A",
    "stroke-opacity": "0.2",
    "stroke-width": "8"
  })
], -1)
const _hoisted_10 = {
  style: {"padding-top":"60px"},
  id: "faq",
  class: "faq"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ell" }, null, -1)
const _hoisted_12 = {
  style: {"position":"relative"},
  class: "container"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " FAQ ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Ticker = _resolveComponent("Ticker")!
  const _component_Advantages = _resolveComponent("Advantages")!
  const _component_Expertise = _resolveComponent("Expertise")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_ExpansionList = _resolveComponent("ExpansionList")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!
  const _component_SignUpDialog = _resolveComponent("SignUpDialog")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      onLogin: _ctx.onClickLogin,
      onReg: _ctx.onClickReg
    }, null, 8, ["onLogin", "onReg"]),
    _createVNode(_component_q_page_container, { style: {"padding-top":"0px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_q_page, null, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('landing.hero.title')), 1),
                    _createElementVNode("h2", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('landing.hero.subtitle')), 1),
                      _hoisted_9
                    ]),
                    _createVNode(_component_Button, {
                      centered: _ctx.$q.screen.width < 1280,
                      class: "hero__btn",
                      onClick: _ctx.onClickReg,
                      text: _ctx.$t('btn.join')
                    }, null, 8, ["centered", "onClick", "text"])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_Ticker, { text: 
            `  Best Offers & High Payouts   Best Offers & High Payouts`
           }),
            _createVNode(_component_Advantages, { onClickReg: _ctx.onClickReg }, null, 8, ["onClickReg"]),
            _createVNode(_component_Expertise, { onClickReg: _ctx.onClickReg }, null, 8, ["onClickReg"]),
            _createVNode(_component_Ticker, { text: 
            `  join to the team of the best!  join to the team of the best!`
           }),
            _createVNode(_component_ContactForm),
            _createElementVNode("section", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_ExpansionList, {
                  items: _ctx.prepareFaqArticles()
                }, null, 8, ["items"])
              ])
            ]),
            _createVNode(_component_LoginDialog, {
              open: _ctx.showLoginDialog,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLoginDialog = false))
            }, null, 8, ["open"]),
            _createVNode(_component_SignUpDialog, {
              open: _ctx.showRegDialog,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRegDialog = false))
            }, null, 8, ["open"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Footer)
  ]))
}